import type { Config } from '@empathyco/playboard-core-domain'
import type { InstanceManagementState, MutationClass } from '../../../models'

export class SetServiceConfigsMutation implements MutationClass {
  static execute(this: void, state: InstanceManagementState, serviceConfigs: Config[]): void {
    state.serviceConfigs = serviceConfigs
  }
}
